import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full bg-h-primary-100 shadow-sm z-10 select-none fixed"
}
const _hoisted_2 = { class: "flex flex-col gap-3 md:flex-row justify-between items-center p-5 pr-[50px]" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-3 text-center" }
const _hoisted_4 = { class: "font-[700]" }
const _hoisted_5 = { id: "chronometer" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "grid grid-cols-12 mt-8 gap-5 items-center" }
const _hoisted_9 = { class: "col-span-12 md:col-span-4 flex justify-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col-span-12 md:col-span-8 flex flex-col gap-5 text-center lg:text-start" }
const _hoisted_12 = { class: "font-bold text-xl" }
const _hoisted_13 = { class: "text-sm w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.message && _ctx.typeAlert === 'quiz' && !_ctx.quizHasEnded && !_ctx.loader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data?.chapter?.concat(" - ")), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.data?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(`p-3 bg-white rounded-lg border flex items-center justify-center gap-2 ${
            _ctx.hasTimeout ? 'text-h-error-400' : ''
          }`)
              }, [
                _createVNode(_component_v_icon, { name: "hi-solid-clock" }),
                _createVNode(_component_CountDown, {
                  time: _ctx.quiz?.duration * 1000,
                  onEnd: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCountdownEnd()))
                }, {
                  default: _withCtx(({ hours, minutes, seconds }) => [
                    _createElementVNode("div", _hoisted_6, [
                      hours
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(String(hours)?.concat("h")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(String(minutes)?.concat("m")), 1),
                      _createElementVNode("p", null, _toDisplayString(String(seconds)?.concat("s")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["time"])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.hasTimeout,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hasTimeout) = $event)),
      closable: false,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '40vw' },
      modal: true,
      showHeader: false,
      contentStyle: "background-color: #F2F8FF"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: require('@/assets/images/avatares/repproved.gif'),
              class: "w-100 rounded-full",
              alt: "repproved img",
              loading: "lazy"
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("quiz.timeout.title")), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("quiz.timeout.info")), 1),
            _createVNode(_component_MessageVoice, {
              msg: _ctx.$t('quiz.timeout.title')?.concat(_ctx.$t('quiz.timeout.info'))
            }, null, 8, ["msg"]),
            _createVNode(_component_Button, {
              class: "btn-primary p-button-sm",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onResult()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("quiz.finalize")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}